define(function(require){
	'use strict';

    var _ = require('underscore');
	var SiteModel 	= require('models/site');
    var AppConfig = require('config/application');

	/*
	*	Коллекция проектов
	*/
	return Backbone.Collection.extend({
		model: SiteModel,

        url: AppConfig.host + '/rest/sites/list',

        parse: function (response) {
            if (response.data !== undefined) {
                return response.data;
            } else {
                return response;
            }
        },

        fetchCallerIds: function() {
            var that = this;
            return Backbone.ajax({
                type: 'GET',
                url: AppConfig.host + '/rest/sites/list',
                success: function(resp) {
                    if(resp.status == 1) {
                        var curProject = _.find(resp.data, {id:app.curProject.id});
                        app.curProject.callerid = curProject.callerid;
                        that.set(resp.data);
                    }
                }
            })
        }
	});
});